import { getProjectPath } from '../paths';
import { TASK_DIALOG_PARAM } from './constants';

export const getTaskPath = (projectId: string, taskId: string, search: string) => {
  const params = new URLSearchParams(search);
  params.set(TASK_DIALOG_PARAM, taskId);
  return `${getProjectPath(projectId)}?${params.toString()}`;
};
